import { render, staticRenderFns } from "./ReportResultTabs.vue?vue&type=template&id=f9bda8da&scoped=true&"
import script from "./ReportResultTabs.vue?vue&type=script&lang=ts&"
export * from "./ReportResultTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ReportResultTabs.vue?vue&type=style&index=0&id=f9bda8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bda8da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBanner,VBtn,VCard,VCardText,VIcon,VRow,VTab,VTabItem,VTabs,VTabsItems})
